import { PostsController } from './posts.controller'

const checkModuleEnabled = [
  '$q',
  '$state',
  '$rootScope',
  ($q, $state, $rootScope) => {
    const deferred = $q.defer()

    $rootScope.getCompanyFeaturesAndAddons()
      .then(({ features }) => {
        if (features['POSTS.ACCESS']) {
          deferred.resolve()
        } else {
          deferred.reject()
        }
      })

    return deferred.promise
      .catch(() => {
        $state.go('home')
      })
  }
]

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('posts', {
      url: '/posts?company&page&post',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        '': {
          templateUrl: '/posts/posts.html?$$REVISION$$',
          controller: PostsController
        },
        'secondLevelMenu@posts': {
          templateUrl: '/posts/posts-sidebar-menu.html?$$REVISION$$'
        }
      }
    })

  $urlRouterProvider.when('/posts/?post', '/posts?post')
}

export const postsRoutes = routes
